module.exports = __webpack_public_path__ + "img/mobile2.f3fda62c.png";